<div (openChange)="startFilter()"
  autoClose="outside"
  class="filter-dropdown"
  ngbDropdown>
  <app-tooltip [dynamic]="false" class="display-inline-flex" message="Filter">
    <button [attr.data-cy]="getCypressTagElement('button')" [ngClass]="getCssButton()"
      class="filter filter-icon iwp-icon-gen_filter"
      ngbDropdownToggle
      tabIndex="-1"
    type="button"></button>
  </app-tooltip>

  <div ngbDropdownMenu class="filter-menu" placement="'bottom-right'">
    @if (spinnerObservable | async) {
      <div class="spinner-container">
        <app-loading-spinner class="center-spinner"></app-loading-spinner>
      </div>
    }
    @if (!disableInputFilter) {
      <div class="filter-all">
        <app-input-text #searchInput
          hasSearchIcon="true"
          class="filter-search-input"
          [hasLabel]="false"
          [initialValue]="$safeNavigationMigration(state?.searchText)"
          (inputValueChange)="onValueChanges($event)"
          [placeholder]="placeHolder"
          [baseCypressTag]="getCypressTag()"
          [alternateBackground]=true
        (keydown.enter)="closeAndSearch()"></app-input-text>
      </div>
    }
    <div class="filter-item">
      <input class="filter-item-code-input" type="checkbox"
        [checked]="allFilter.checked"
        [indeterminate]="allFilter.indeterminate"
        (change)="toggleAllCode($event)"
        (keydown.enter)="closeAndSearch()"
        id="{{filterName}}-code-filter-all" [attr.data-cy]="filterName + '-code-filter-all'">
      <label class="filter-item-code-label text-ellipsis" for="{{filterName}}-code-filter-all"
      [textContent]="allFilter.name"></label>
    </div>
    <div class="separator"></div>
    <div class="filter-scroll" [attr.data-cy]="filterName + '-filter-scroll'">
      @if (hasEmptyOption && showingEmptyOption) {
        <div class="filter-item">
          <input (change)="toggleEmptyCode($event)"
            (keydown.enter)="closeAndSearch()"
            [attr.data-cy]="filterName + '-code-filter-empty'"
            [checked]="emptyFilter.checked"
            [indeterminate]="emptyFilter.indeterminate"
            class="filter-item-code-input"
            id="{{filterName}}-code-filter-empty" type="checkbox">
          <label [attr.data-cy]="filterName + '-code-filter-empty-label'" [textContent]="emptyFilter.name"
            class="filter-item-code-label text-ellipsis"
          for="{{filterName}}-code-filter-empty"></label>
        </div>
      }
      @for (code of state.filteredCodes; track code; let index = $index) {
        <div class="filter-item" [attr.data-cy]="filterName + '-filter-item'">
          @if (code.children) {
            <div (click)="changeCodeFilterAccordionStatus(code)"
              class="accordion-icon-container">
              <span data-cy="code-filter-accordion-icon" class="accordion-icon"
                id="{{filterName}}-accordion-{{code.code}}"
                [ngClass]="{'iwp-icon-gen_arrow_right':!code.isOpen,'iwp-icon-gen_arrow_down': code.isOpen}">
              </span>
            </div>
          }
          <div class="filter-item-code">
            <input class="filter-item-code-input" type="checkbox"
              [checked]="code.checked" [indeterminate]="code.indeterminate"
              (change)="toggleCode(code, $event)"
              (keydown.enter)="closeAndSearch()"
              id="{{filterName}}-code-filter-{{code.code}}-{{index}}"
              [attr.data-cy]="filterName + '-code-filter-' + code.code">
            <app-tooltip [message]="getTooltipText(code)"
              [dynamic]="getTooltipIsDynamic(code)">
              <label class="filter-item-code-label"
                for="{{filterName}}-code-filter-{{code.code}}-{{index}}"
              [textContent]="code | prettyPrintReference: formatWithoutCode"></label>
            </app-tooltip>
          </div>
        </div>
        @if (code.children) {
          <div>
            @for (child of code.children; track child) {
              @if (code.isOpen) {
                <div class="filter-item-child text-ellipsis"
                  [attr.data-cy]="filterName + '-filter-item-child'">
                  <input class="filter-item-code-input" type="checkbox"
                    [checked]="child.checked"
                    (change)="toggleCode(child, $event)"
                    (keydown.enter)="closeAndSearch()"
                    id="{{filterName}}-child-code-filter-{{child.code}}-{{index}}"
                    [attr.data-cy]="filterName + '-child-code-filter-' + child.code">
                  <app-tooltip [message]="getTooltipText(child)"
                    [dynamic]="getTooltipIsDynamic(child)">
                    <label class="filter-item-code-label"
                      for="{{filterName}}-child-code-filter-{{child.code}}-{{index}}"
                    [textContent]="child | prettyPrintReference: formatWithoutCode"></label>
                  </app-tooltip>
                </div>
              }
            }
          </div>
        }
      }
    </div>
    <app-filter-footer
      (applyClick)="closeAndSearch()"
      (clearClick)="clear()"
      [filterName]="filterName">
    </app-filter-footer>
  </div>
</div>
